import(/* webpackMode: "eager" */ "/home/runner/work/landing-page/landing-page/app/error.tsx");
